/**
 * Krok UXV4c — pevny seznam poli naboru pro prohlizec.
 *
 * KOPIE `INTAKE_FIELDS` z `@reos/field-intake` (+ jednotka z registru
 * FACT_KEYS): kontext do prohlizecoveho bundlu smi jen jako typ
 * (`test/browser-safe-imports.spec.ts`), proto lokalni kopie — a test
 * parity `fields.spec.ts`, ktery pri rozchodu spadne (vzor `gate-catalog.ts`).
 */

export interface IntakeFieldView {
  readonly factKey: string;
  readonly group: 'property' | 'sale';
  readonly valueType: 'number' | 'integer' | 'text' | 'boolean' | 'money' | 'date';
  readonly unit: string | null;
  readonly checklist: boolean;
}

export const INTAKE_FIELD_DEFS: readonly IntakeFieldView[] = [
  { factKey: 'disposition', group: 'property', valueType: 'text', unit: null, checklist: true },
  { factKey: 'usable_area_m2', group: 'property', valueType: 'number', unit: 'm2', checklist: true },
  { factKey: 'living_area_m2', group: 'property', valueType: 'number', unit: 'm2', checklist: false },
  { factKey: 'land_area_m2', group: 'property', valueType: 'number', unit: 'm2', checklist: false },
  { factKey: 'condition', group: 'property', valueType: 'text', unit: null, checklist: true },
  { factKey: 'renovation_note', group: 'property', valueType: 'text', unit: null, checklist: true },
  { factKey: 'heating_type', group: 'property', valueType: 'text', unit: null, checklist: true },
  { factKey: 'build_year', group: 'property', valueType: 'integer', unit: null, checklist: false },
  { factKey: 'energy_class', group: 'property', valueType: 'text', unit: null, checklist: false },
  { factKey: 'energy.monthly_costs', group: 'property', valueType: 'money', unit: null, checklist: true },
  { factKey: 'sale.deadline', group: 'sale', valueType: 'text', unit: null, checklist: true },
  { factKey: 'sale.reason', group: 'sale', valueType: 'text', unit: null, checklist: true },
  { factKey: 'sale.has_lien', group: 'sale', valueType: 'boolean', unit: null, checklist: true },
  { factKey: 'sale.owner_price_expectation', group: 'sale', valueType: 'money', unit: null, checklist: true },
  { factKey: 'sale.exclusivity', group: 'sale', valueType: 'boolean', unit: null, checklist: true },
  { factKey: 'sale.available_from', group: 'sale', valueType: 'text', unit: null, checklist: true },
  // Krok PIL1 (vada V10): kontakt majitele — duvod v `@reos/field-intake`.
  { factKey: 'owner.contact_name', group: 'sale', valueType: 'text', unit: null, checklist: true },
  { factKey: 'owner.contact_phone', group: 'sale', valueType: 'text', unit: null, checklist: true },
  { factKey: 'owner.contact_email', group: 'sale', valueType: 'text', unit: null, checklist: false },
  // Krok WEBP3: rozhodovaci udaje verejne nabidky — duvod v `@reos/field-intake`.
  { factKey: 'renovation_year', group: 'property', valueType: 'integer', unit: null, checklist: false },
  // Krok PROP5: SVJ jednou a termin predani jen pod `sale.available_from`
  // (duvod v `@reos/field-intake`).
  { factKey: 'svj_name', group: 'property', valueType: 'text', unit: null, checklist: false },
  { factKey: 'svj_entity_id', group: 'property', valueType: 'text', unit: null, checklist: false },
  { factKey: 'svj_advances_monthly', group: 'property', valueType: 'money', unit: null, checklist: false },
  { factKey: 'svj_contribution_monthly', group: 'property', valueType: 'money', unit: null, checklist: false },
  { factKey: 'svj_repair_fund_balance', group: 'property', valueType: 'money', unit: null, checklist: false },
  { factKey: 'svj_finance_debt', group: 'property', valueType: 'boolean', unit: null, checklist: false },
  { factKey: 'svj_advances_for_people', group: 'property', valueType: 'integer', unit: null, checklist: false },
  { factKey: 'commercial.permitted_use', group: 'property', valueType: 'text', unit: null, checklist: false },
  { factKey: 'commercial.vat_regime', group: 'property', valueType: 'text', unit: null, checklist: false },
  { factKey: 'rent.deposit', group: 'sale', valueType: 'money', unit: null, checklist: false },
  { factKey: 'rent.commission', group: 'sale', valueType: 'money', unit: null, checklist: false },
  { factKey: 'rent.commission_payer', group: 'sale', valueType: 'text', unit: null, checklist: false },
  { factKey: 'rent.term', group: 'sale', valueType: 'text', unit: null, checklist: false },
  { factKey: 'rent.pets_allowed', group: 'sale', valueType: 'boolean', unit: null, checklist: false },
  { factKey: 'rent.available_from', group: 'sale', valueType: 'text', unit: null, checklist: false },
];
